export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À Propos',
      activities: 'Nos Activités',
      engagement: 'Engagement & Qualité',
      gallery: 'Galerie',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'Barkatis Group',
        subtitle: 'Un héritage d\'excellence, une vision sans frontière',
        cta: 'Découvrir nos activités'
      },
      intro: {
        title: 'Plus de 30 ans d\'expertise',
        description: 'Depuis 1993, Barkatis Group incarne l\'excellence tunisienne à travers trois pôles stratégiques : l\'agro-alimentaire, l\'industrie et l\'art & design.'
      }
    },
    about: {
      title: 'Un Héritage d\'Excellence, une Vision sans Frontières',
      history_title: 'Notre Histoire : Plus de 30 ans d\'engagement',
      history_text: 'L\'histoire de Barkatis Group prend racine en 1993, sous l\'impulsion de son fondateur, M. Bechir Barkatis. Ce qui débuta comme une entreprise spécialisée dans la fourniture industrielle est devenu, en trois décennies, un consortium multisectoriel de premier plan en Tunisie.',
      poles_title: 'Nos Pôles d\'Expertise',
      pole_industry: 'Pôle Industrie & Technique',
      pole_art: 'Pôle Art & Design',
      pole_agro: 'Pôle Agricole & Agro-Alimentaire',
      why_title: 'Pourquoi choisir Barkatis Group ?',
      leader_title: 'Le Mot du Dirigeant',
      leader_quote: '"Depuis 1993, le nom Barkatis est synonyme de confiance. En unissant nos forces industrielles, artistiques et agricoles, nous avons créé un écosystème capable d\'exporter l\'excellence tunisienne."'
    },
    activities: {
      title: 'Nos Activités',
      subtitle: 'Barkatis Group déploie son expertise à travers trois pôles stratégiques',
      agro_title: 'Pôle Agro-Alimentaire & Agricole',
      agro_desc: 'La maîtrise de la terre et de la valorisation du terroir',
      industry_title: 'Pôle Industrie & Technique',
      industry_desc: 'Le socle historique de notre performance',
      art_title: 'Pôle Art & Design',
      art_desc: 'L\'alliance de l\'esthétique et de l\'innovation'
    },
    engagement: {
      title: 'Engagement & Qualité',
      subtitle: 'La qualité n\'est pas une option, c\'est notre signature depuis 1993',
      quality_title: 'Notre Charte Qualité',
      env_title: 'Engagement Environnemental & Durable',
      social_title: 'Engagement Social & Sociétal',
      export_title: 'Nos Standards d\'Export'
    },
    gallery: {
      title: 'Galerie Produits',
      all: 'Tous',
      oil: 'Huiles',
      mosaic: 'Mosaïques'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Barkatis Group est à votre écoute',
      form_title: 'Formulaire de Contact',
      name: 'Nom complet',
      company: 'Entreprise (optionnel)',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer',
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi',
      headquarters: 'Siège Social',
      hours: 'Lundi - Vendredi : 08:00 - 17:00'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      activities: 'Our Activities',
      engagement: 'Commitment & Quality',
      gallery: 'Gallery',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'Barkatis Group',
        subtitle: 'A heritage of excellence, a vision without borders',
        cta: 'Discover our activities'
      },
      intro: {
        title: 'Over 30 years of expertise',
        description: 'Since 1993, Barkatis Group embodies Tunisian excellence through three strategic divisions: agri-food, industry, and art & design.'
      }
    },
    about: {
      title: 'A Heritage of Excellence, a Vision Without Borders',
      history_title: 'Our History: Over 30 Years of Commitment',
      history_text: 'The story of Barkatis Group began in 1993, driven by its founder, Mr. Bechir Barkatis. What started as a company specializing in industrial supply has become, in three decades, a leading multisectoral consortium in Tunisia.',
      poles_title: 'Our Areas of Expertise',
      pole_industry: 'Industry & Technical Division',
      pole_art: 'Art & Design Division',
      pole_agro: 'Agricultural & Agri-Food Division',
      why_title: 'Why Choose Barkatis Group?',
      leader_title: 'Message from Leadership',
      leader_quote: '"Since 1993, the Barkatis name has been synonymous with trust. By uniting our industrial, artistic, and agricultural strengths, we have created an ecosystem capable of exporting Tunisian excellence."'
    },
    activities: {
      title: 'Our Activities',
      subtitle: 'Barkatis Group deploys its expertise through three strategic divisions',
      agro_title: 'Agri-Food & Agricultural Division',
      agro_desc: 'Mastering the land and enhancing local terroir',
      industry_title: 'Industry & Technical Division',
      industry_desc: 'The historic foundation of our performance',
      art_title: 'Art & Design Division',
      art_desc: 'The alliance of aesthetics and innovation'
    },
    engagement: {
      title: 'Commitment & Quality',
      subtitle: 'Quality is not an option, it\'s our signature since 1993',
      quality_title: 'Our Quality Charter',
      env_title: 'Environmental & Sustainable Commitment',
      social_title: 'Social & Community Commitment',
      export_title: 'Our Export Standards'
    },
    gallery: {
      title: 'Product Gallery',
      all: 'All',
      oil: 'Oils',
      mosaic: 'Mosaics'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Barkatis Group is listening',
      form_title: 'Contact Form',
      name: 'Full Name',
      company: 'Company (optional)',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      success: 'Message sent successfully!',
      error: 'Error sending message',
      headquarters: 'Headquarters',
      hours: 'Monday - Friday: 08:00 AM - 05:00 PM'
    }
  }
};